import React, { useContext } from 'react';
import styled from 'styled-components';
import { Context } from '@components/Context';
import Colors from '@components/shared/Colors';
import { P, H, H1, H2, H3 } from '@components/shared/Typography';
import { CartItem } from '@contracts';

interface Props {
  item: CartItem;
  editable: boolean;
}

const RemoveFromCart: React.FC<Props> = ({ item, editable }) => {
  const { dispatch } = useContext(Context);

  if (!editable) return <Spacer className="cart-item-remove" />;

  const removeCartItem = () => {
    dispatch({ type: 'cartItemRemove', data: item });
  };

  return (
    <CartItemRemove onClick={removeCartItem} className="cart-item-remove">
      &times;
    </CartItemRemove>
  );
};

export default RemoveFromCart;

const Spacer = styled.div`
  width: 25px;
`;

const CartItemRemove = styled.button`
  font-size: 18px;
  line-height: 1;
  font-family: 'BrownStd';
  font-weight: bold;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0.5;
  margin-top: -1px;
  height: 26px;
  width: 26px;
  color: ${Colors.navyBlue};
  flex-shrink: 0;

  &:hover {
    opacity: 1;
  }
`;
